import Image from "next/image";
import React from "react";

export type NoneAnalysisProps = {
  image: string;
  message: string;
  onClickCreate?: React.MouseEventHandler<HTMLButtonElement>;
};

/**
 * 分析記事がない場合に表示するイラストメッセージコンポーネント
 */
export default function NoneAnalysis({ image, message, onClickCreate }: NoneAnalysisProps) {
  return (
    <div className="flex flex-col items-center">
      {/* イラスト */}
      <div className="relative block size-48 sm:size-60">
        {/* <Image alt="イラスト" src={NoUserAnalysis} fill /> */}
        <Image
          alt="イラスト"
          src={image}
          fill
        />
      </div>

      {/* メッセージ */}
      {/* （改行コードがある場合、改行タグに置換）*/}
      <p className="text-center text-base leading-6 text-GRAY_1">
        {message.split("\n").map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </p>

      {/* 必要に応じてUIを提示 */}
      {onClickCreate && (
        <div className="mt-5">
          <button
            onClick={onClickCreate}
            className="block rounded-full bg-PINK_1 px-4 py-1 text-center text-sm text-WHITE_1 hover:bg-PINK_1/75"
          >
            分析記事を作成
          </button>
        </div>
      )}
    </div>
  );
}
